import { render, staticRenderFns } from "./yearly-report-for-employee.vue?vue&type=template&id=0a4d373f&scoped=true&"
import script from "./yearly-report-for-employee.vue?vue&type=script&lang=ts&"
export * from "./yearly-report-for-employee.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4d373f",
  null
  
)

export default component.exports